import { render } from "./widgetCustomer.vue?vue&type=template&id=299f17be"
import script from "./widgetCustomer.vue?vue&type=script&lang=js"
export * from "./widgetCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__